import { render, staticRenderFns } from "./placeholder.vue?vue&type=template&id=e604b2e2&scoped=true"
import script from "./placeholder.vue?vue&type=script&lang=js"
export * from "./placeholder.vue?vue&type=script&lang=js"
import style0 from "./placeholder.vue?vue&type=style&index=0&id=e604b2e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e604b2e2",
  null
  
)

export default component.exports